<input
  type="text"
  [bsConfig]="{
    dateInputFormat: 'YYYY-MM-DD',
    containerClass: 'theme-dark-blue'
  }"
  [isOpen]="true"
  [bsValue]="value"
  (bsValueChange)="onChangeDate($event)"
  (onShown)="onShown($event)"
  (onHidden)="onHidden($event)"
  #picker="bsDatepicker"
  bsDatepicker
/>
